export const GET_INIT_EXAM_DATA = 'GET_INIT_EXAM_DATA';